export default __webpack_public_path__ + "static/media/website.05288f12.svg";